import { Speaker } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { timeAgoFromToday } from '@avantstay/backoffice-core'

import { clipText } from '@new/domains/operations/utils/text'

import { GuestInboxTimelineEvent } from '../../StayTimeline.types'
import { toDate } from '../../StayTimeline.utils'
import { RoleTag, RoleTone } from '../Shared.styles'
import * as S from './CaseNote.styles'

interface CaseNoteProps {
  event: GuestInboxTimelineEvent
}

const BODY_CLIP = 420

interface Role {
  tone: RoleTone
  label: string
}

const TEAM_ROLE: Role = { tone: 'team', label: 'AvantStay' }
const SYSTEM_ROLE: Role = { tone: 'system', label: 'system' }

const ROLES: Partial<Record<Speaker, Role>> = {
  [Speaker.teammate]: TEAM_ROLE,
  [Speaker.vendor]: { tone: 'vendor', label: 'field / vendor' },
  [Speaker.system]: SYSTEM_ROLE,
  [Speaker.automation]: SYSTEM_ROLE,
}

export const CaseNote = ({ event }: CaseNoteProps) => {
  const role = ROLES[event.speaker] ?? TEAM_ROLE
  const at = toDate(event.at)

  return (
    <S.Root>
      <S.Head>
        <S.Author>{event.who || 'Someone'}</S.Author>
        <RoleTag $tone={role.tone}>{role.label}</RoleTag>
        <S.Meta>case update{at ? ` · ${timeAgoFromToday(at)}` : ''}</S.Meta>
      </S.Head>
      <S.Body>{clipText(event.body, BODY_CLIP)}</S.Body>
    </S.Root>
  )
}
